import styled from 'styled-components';
export const AsideMenuWrapper = styled.div `
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 0;
  gap: 0 4px;
`;
//# sourceMappingURL=AsideMenu.styled.js.map